import { TextField } from '@mui/material'
import { GridFilterInputValueProps } from '@mui/x-data-grid'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchSuppliers } from '@omnea-app/fe-form-viewer/useSearchSuppliers'
import { BaseAutocomplete } from '@omnea-app/omui/BaseAutocomplete'
import { useAutocompleteFilter } from './autocompleteFilterUtils'

export const SupplierSearchInputFilter = ({ item, applyValue }: GridFilterInputValueProps) => {
  const { t } = useTranslation('shared')

  const { inputValue, isMultiSelect, safeValue, handleInputChange, handleChange } = useAutocompleteFilter({
    item,
    applyValue,
  })

  const { data, isFetching } = useSearchSuppliers({ name: inputValue, includeGlobal: false })

  const options = useMemo(() => data?.suppliers?.map((supplier) => supplier.name) ?? [], [data?.suppliers])

  return (
    <BaseAutocomplete
      freeSolo
      multiple={isMultiSelect}
      autoHighlight
      loading={isFetching}
      value={safeValue}
      inputValue={inputValue}
      onInputChange={handleInputChange}
      disableCloseOnSelect={isMultiSelect}
      disableClearable={false}
      onChange={handleChange}
      options={options}
      filterOptions={(x) => x}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={t('table-filters.filter-value-placeholder')}
          slotProps={{
            input: { ...params.InputProps, sx: { border: 'secondary.main' } },
            inputLabel: { shrink: true },
          }}
        />
      )}
    />
  )
}
